import { useUser } from '../auth/useAuth';
import React, { useState } from 'react';
import { Btn } from '../components/chancey';
import { SupportPageLayout } from '../components/layout/SupportPageLayout';
import { FAQS } from '../data/supportContent';
import { useChanceyTheme } from '../theme/ThemeContext';
import { openFeedback } from '../utils/feedback';

const HelpCenterPage: React.FC = () => {
  const { c, typ } = useChanceyTheme();
  const { user } = useUser();
  const [open, setOpen] = useState<Record<string, boolean>>({});

  const toggle = (key: string) => setOpen((prev) => ({ ...prev, [key]: !prev[key] }));

  return (
    <SupportPageLayout title="Help Center" eyebrow="Support">
      {FAQS.map((cat) => (
        <div key={cat.id}>
          <div
            className="px-[18px] pb-2 text-[11px] font-semibold uppercase tracking-[0.1em]"
            style={{ color: c.inkMuted, fontFamily: typ.body }}
          >
            {cat.title}
          </div>
          <div
            className="overflow-hidden rounded-[18px] border"
            style={{ background: c.surface, borderColor: c.line }}
          >
            {cat.items.map((item, i) => {
              const key = `${cat.id}.${i}`;
              const isOpen = !!open[key];
              const isLast = i === cat.items.length - 1;
              return (
                <div
                  key={key}
                  style={{ borderBottom: isLast ? 'none' : `0.5px solid ${c.line}` }}
                >
                  <button
                    type="button"
                    onClick={() => toggle(key)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center gap-3 px-4 py-3.5 text-left"
                  >
                    <div
                      className="min-w-0 flex-1 text-sm"
                      style={{
                        fontFamily: typ.body,
                        color: c.ink,
                        fontWeight: 500,
                      }}
                    >
                      {item.q}
                    </div>
                    <span
                      aria-hidden
                      className="shrink-0 transition-transform"
                      style={{
                        color: c.inkMuted,
                        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                        display: 'inline-block',
                        fontSize: 12,
                        lineHeight: 1,
                      }}
                    >
                      ▾
                    </span>
                  </button>
                  {isOpen ? (
                    <div
                      className="px-4 pb-4 pt-0 text-[13.5px] leading-relaxed"
                      style={{ color: c.inkSoft, fontFamily: typ.body }}
                    >
                      {item.a}
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      ))}

      <div
        className="mt-2 flex flex-col items-start gap-2 rounded-[18px] border p-4"
        style={{ background: c.surface, borderColor: c.line }}
      >
        <div
          className="text-sm"
          style={{ fontFamily: typ.body, color: c.ink, fontWeight: 600 }}
        >
          Still need help?
        </div>
        <div
          className="text-[13px] leading-snug"
          style={{ color: c.inkSoft, fontFamily: typ.body }}
        >
          Send us a note — we read every email and include your app version automatically so we
          can help faster.
        </div>
        <Btn
          c={c}
          typ={typ}
          variant="primary"
          onClick={() => openFeedback(user?.id)}
          style={{ alignSelf: 'stretch' }}
        >
          Email support
        </Btn>
      </div>
    </SupportPageLayout>
  );
};

export default HelpCenterPage;
